import { lazy } from 'react';

const CountUp = lazy(() => import('./CountUp'));

export { CountUp };
